import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  enrollNowButtonText: {
    id: 'valueaddprograms.enrollment.button.text',
    description: 'Text for value add program enrollment button',
    defaultMessage: 'Enroll Now'
  },
  learnMoreButtonText: {
    id: 'valueaddprograms.learnmore.button.text',
    description: 'Text for value add program learn more button',
    defaultMessage: 'Learn More'
  }
});
